import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Session } from 'types/session';

export const initialUserState: Session = {
  user: {
    id: '',
    email: '',
    password: '',
    firstName: '',
    middleName: '',
    lastName: '',
    address: '',
    state: '',
    zipcode: 0,
    phone: '',
    profileImage: '',
    accountType: '',
    pro: false,
  },
  tokens: {
    access: {
      token: '',
      expires: new Date(),
    },
    refresh: {
      token: '',
      expires: new Date(),
    },
  },
  signedUrl: '',
};

export const initialAuthState = {
  currentUser: initialUserState,
  loading: false,
  errors: {
    login: null,
    logout: null,
    refreshToken: null,
    register: null,
  },
};

const slice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    saveUserInfo(state, action: PayloadAction<Session>) {
      state.currentUser = action.payload;
    },
    logout(state) {
      state.currentUser = initialUserState;
    },
    updateTokens(state, action: PayloadAction<any>) {
      console.log(action.payload);
      state.currentUser.tokens = action.payload;
    },
  },
});

export const AuthActions = {
  ...slice.actions,
};

export const authReducer = slice.reducer;
